import styled from 'react-emotion'

const Tabs = styled('div')({
    display: 'flex',
    height: 120,
    background: '#fff',
    zIndex: 100,
    boxShadow: '0 0 10px rgba(0,0,0,0.4)',
    '@media (max-width: 500px)': {
        height: 100
    }
})

export default Tabs


// WEBPACK FOOTER //
// ./src/components/TabsComponent.jsx